var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDreidel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.624 223.964C7 236.466 0 253.468 0 271.221V413.116C0 450.121 29.873 480 66.87 480H208.735C226.359 480 243.358 472.999 255.982 460.372L314.853 401.489L78.495 165.081L19.624 223.964ZM443.219 59.191L420.721 36.688C414.471 30.437 404.222 30.437 398.097 36.688L289.105 145.703L217.235 73.693C204.111 60.692 182.987 60.692 169.863 73.693L101.243 142.453L337.601 378.861L406.222 310.226C419.346 297.099 419.346 275.972 406.222 262.845L334.227 190.96L443.219 81.944C449.594 75.694 449.594 65.567 443.219 59.191Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDreidel);
export default __webpack_public_path__ + "static/media/dreidel.87d2a127ad81851bad200549de2f888a.svg";
export { ForwardRef as ReactComponent };